import Vue from "vue";
import profisApi from "../profis/api";

export default {
  install() {
    Vue.prototype.$api = profisApi;
  }
};
